import { ColumnDef } from "@tanstack/react-table";
import { getUserFullName } from "@/core/utils/name";
import { DetailedUserWithStats } from "@/user/user.d";

export const NameCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Name",
  accessorFn: (row) => getUserFullName(row),
  enableSorting: true,
});
